import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import styles from "./EvaluationMainContent.module.css";
import PDFViewer from "@components/pdfviewer/PDFViewer";
import type { QuestionWithEvaluation, Document } from "@services/evaluationService";
import { useShortcut } from "@hooks/useShortCut";
import { handleKeydown } from "@store/ShortCutManager";
interface EvaluationMainContentProps {
  question: QuestionWithEvaluation;
  studentAnswerDocument?: Document;
}

function EvaluationMainContent({ question, studentAnswerDocument }: EvaluationMainContentProps) {
  const [activeTab, setActiveTab] = useState("question");

  useLayoutEffect(() => {
    window.addEventListener("keydown", handleKeydown);
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, [handleKeydown]);

    useShortcut("alt+1", () => {
      setActiveTab((prev) => (prev === "question" ? "" : "question"))
    });
    useShortcut("alt+2", () => {
      setActiveTab((prev) => (prev === "rubric" ? "" : "rubric"))
    });
    useShortcut("alt+3", () => {
      setActiveTab((prev) => (prev === "solution" ? "" : "solution"))
    });

  const getPdfUrl = () => {
    switch (activeTab) {
      case "rubric":
        return question?.question?.rubric_document?.signed_url;
      case "solution":
        return question?.question?.sample_answers?.[0]?.document?.signed_url;
      default:
        return question?.question?.document?.signed_url;
    }
  };
  return (
    <div className={styles.leftSidePanel}>
      <div className={styles.tabBar}>
        <button title="Alt + 1"
          className={activeTab === "question" ? styles.tabActive : styles.tab}
          onClick={() =>
            setActiveTab((prev) => (prev === "question" ? "" : "question"))
          }
        >
          View Question {question?.question?.sequence_number}
        </button>
        <button title="Alt + 2"
          className={activeTab === "rubric" ? styles.tabActive : styles.tab}
          onClick={() =>
            setActiveTab((prev) => (prev === "rubric" ? "" : "rubric"))
          }
        >
          View Rubric
        </button>
        <button title="Alt + 3"
          className={activeTab === "solution" ? styles.tabActive : styles.tab}
          onClick={() =>
            setActiveTab((prev) => (prev === "solution" ? "" : "solution"))
          }
        >
          View Solution
        </button>
      </div>
      <div
        className={`${styles.slideContainer} ${
          activeTab ? styles.open : styles.closed
        }`}
      >
        <p className={styles.sectionTitle}>
          {activeTab
            ? activeTab === "question"
              ? `Question ${question?.question?.sequence_number}`
              : activeTab === "rubric"
              ? "Rubric"
              : "Solution"
            : ""}
        </p>
        <div className={styles.questionSection}>
          <PDFViewer
            pdfUrl={getPdfUrl()}
            title={activeTab}
            style={{ height: "348px" }}
          />
        </div>
      </div>
      <p>Student Answer</p>
      <div className={styles.studentPdfSection}>
        <PDFViewer
          pdfUrl={studentAnswerDocument?.signed_url || ""}
          title="PDF Answer Sheet"
          pageMapping={question?.page_mapping}
        />
        {!studentAnswerDocument && (
          <p className={styles.note}>
            No student answer document available
          </p>
        )}
      </div>
    </div>
  );
}

export default EvaluationMainContent;
